module.exports = __webpack_public_path__ + "img/fwx5.e72735ed.png";